import { skipToken } from "@apollo/client";
import type { SuspenseQueryHookOptions } from "@apollo/client";
import { useMutationHandler } from "@sinch/hooks/useMutationHandler";
import { useSuspenseQueryHandler } from "@sinch/hooks/useSuspenseQueryHandler";
import { CreateInterval, DeleteInterval, EditInterval, RateInterval } from "./queries.graphql";
import type {
  CreateIntervalMutation,
  CreateIntervalMutationVariables,
  DeleteIntervalMutation,
  DeleteIntervalMutationVariables,
  EditIntervalMutation,
  EditIntervalMutationVariables,
  RateIntervalQuery,
  RateIntervalQueryVariables,
} from "./queries.types";

interface UseRateIntervalProps {
  id?: string;
  queryOptions?: Omit<SuspenseQueryHookOptions<RateIntervalQuery, RateIntervalQueryVariables>, "variables">;
}

export const useRateInterval = (props?: UseRateIntervalProps) => {
  const id = props?.id;

  const [deleteInterval, { loading: deleteLoading }] = useMutationHandler<
    DeleteIntervalMutation,
    DeleteIntervalMutationVariables
  >(DeleteInterval);
  const [createInterval, { loading: createLoading }] = useMutationHandler<
    CreateIntervalMutation,
    CreateIntervalMutationVariables
  >(CreateInterval);
  const [editInterval, { loading: editLoading }] = useMutationHandler<
    EditIntervalMutation,
    EditIntervalMutationVariables
  >(EditInterval);

  const { data } = useSuspenseQueryHandler<RateIntervalQuery, RateIntervalQueryVariables>(
    RateInterval,
    id ? { id } : undefined,
    id ? (props?.queryOptions ?? {}) : skipToken
  );

  return {
    create: createInterval,
    edit: editInterval,
    remove: deleteInterval,
    loading: deleteLoading || editLoading || createLoading,
    rateInterval: data,
  };
};
